<div class="container">
  <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode(), 'light-filter': !isDarkMode() }">
    <form [formGroup]="filterForm">
      <div class="row">
        <div class="col">
          <app-custom-date-picker
            [label]="'From Date:'"
            [controlname]="this.filterForm.controls['from_date']"
          ></app-custom-date-picker>
        </div>
        <div class="col">
          <app-custom-date-picker
            [label]="'To Date:'"
            [controlname]="this.filterForm.controls['to_date']"
          ></app-custom-date-picker>
        </div>
        <div class="col">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Segment"
            placeholder="Select Segment"
            [options]="segmentOptions"
            [(selected)]="selectedSegments"
          ></app-pc-multi-select-filter>
        </div>
        <div class="col">
          <app-pc-multi-select-filter [lightMode]="!isDarkMode()"
            label="Cargo Operation"
            placeholder="Select Cargo Operation"
            [options]="cargoOperation"
            [(selected)]="selectedCargoOperations"
          ></app-pc-multi-select-filter>
        </div>
        <div class="col">
          <label
            class="shipNameLabel"
            [ngClass]="{ 'dark-label': isDarkMode() }"
            >Ship Name</label
          >
          <input
            type="text"
            class="form-control"
            id="shipName"
            formControlName="shipName"
            (input)="filterShipNames($event)"
            [matAutocomplete]="autoShip"
          />
          <mat-autocomplete #autoShip="matAutocomplete">
            <mat-option
              *ngFor="let ship of shipNameSuggestions"
              [value]="ship.shipName"
            >
              {{ ship.shipName }}
            </mat-option>
          </mat-autocomplete>
        </div>
        <div class="col">
          <app-custom-input
            placeholder="I.M.O Number"
            label="I.M.O Number"
            [controlname]="this.filterForm.controls['imoNumber']"
          ></app-custom-input>
        </div>
        <div class="filterBtn col-md1">
          <button
            class="btn btn-light hover-button apply"
            (click)="clearClick()"
          >
            <mat-icon>clear_all</mat-icon>
            <span class="name">Clear Filter</span>
          </button>
        </div>
        <div class="filterBtn">
          <button
            class="btn btn-light hover-button apply"
            (click)="filterClick()"
          >
            <mat-icon class="filterIcon">filter_list</mat-icon>
            <span class="name">Apply Filter</span>
          </button>
        </div>
      </div>
    </form>
  </div>
  <h2 class="tableTitle" [ngClass]="{ 'dark-tableTitle': isDarkMode() }">
    {{ tableName }}
  </h2>
  <span class="text-right togglebtn"
    >
    <!-- <button
      class="btn btn-light hover-button apply refresh"
      (click)="editClick()"
    >
      <span class="name">Update Vessel Status</span>
    </button> -->
    <button
      class="btn pc-back-btn fetchData"
      (click)="goBack()"
    >
      <mat-icon style="vertical-align: middle; margin-right: 6px"
        >undo</mat-icon
      >
      <span style="vertical-align: middle">Back</span>
    </button></span
  >

  <div class="table-container scroll-bar">
    <table
      class="mat-elevation-z8 printable-table"
      #table
      id="style-4"
      matSort
      [ngClass]="{ 'dark-table': isDarkMode() }"
    >
      <thead class="sticky-header">
        <tr>
          <th class="th-text-center2" mat-sort-header="sNo">S.No</th>
          <th class="th-text-center3" mat-sort-header="vessel_name">
            Vessel Name
          </th>
          <th class="th-text-center2" mat-sort-header="vessel_imo">
            Vessel IMO
          </th>
          <th class="th-text-center2" mat-sort-header="vessel_type">
            Vessel Type
          </th>
          <th class="th-text-center2" mat-sort-header="port_name">Port Name</th>
          <th
            *ngIf="
              ![
                'shipUnderperformanceTcp',
                'Idle',
                'Transit',
                'CargoOperations'
              ].includes(activeTab)
            "
            class="th-text-center2"
            mat-sort-header="actual_cargo_ops_consumption"
          >
            Actual Cargo Ops Consumption
          </th>
          <th
            *ngIf="
              ![
                'shipUnderperformanceTcp',
                'Idle',
                'Transit',
                'CargoOperations'
              ].includes(activeTab)
            "
            class="th-text-center2"
            mat-sort-header="cargo_ops_consumption_design"
          >
            Cargo Ops Consumption Design
          </th>
          <th
            *ngIf="
              ![
                'shipUnderperformanceTcp',
                'Idle',
                'Transit',
                'CargoOperations'
              ].includes(activeTab)
            "
            class="th-text-center2"
            mat-sort-header="actual_idle_consumption"
          >
            Actual Idle Consumption
          </th>
          <th
            *ngIf="
              ![
                'shipUnderperformanceTcp',
                'Idle',
                'Transit',
                'CargoOperations'
              ].includes(activeTab)
            "
            class="th-text-center2"
            mat-sort-header="idle_consumption_design"
          >
            Idle Consumption Design
          </th>
          <th
            *ngIf="
              ![
                'shipUnderperformanceTcp',
                'Idle',
                'Transit',
                'CargoOperations'
              ].includes(activeTab)
            "
            class="th-text-center2"
            mat-sort-header="actual_maneuvering_consumption"
          >
            Actual Maneuvering Consumption
          </th>
          <th
            *ngIf="
              ![
                'shipUnderperformanceTcp',
                'Idle',
                'Transit',
                'CargoOperations'
              ].includes(activeTab)
            "
            class="th-text-center2"
            mat-sort-header="maneuvering_consumption_design"
          >
            Design Maneuvering Consumption
          </th>
          <th
            *ngIf="['shipUnderperformanceTcp'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="actual_consumption_design"
          >
            Actual Cargo Ops
          </th>
          <th
            *ngIf="['shipUnderperformanceTcp'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="actual_idle"
          >
            Actual Idle
          </th>
          <th
            *ngIf="['shipUnderperformanceTcp'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="actual_maneuvering"
          >
            Actual Maneuvering
          </th>
          <th
            *ngIf="['shipUnderperformanceTcp'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="cargo_ops_consumption_tcp"
          >
            Cargo Ops TCP
          </th>
          <th
            *ngIf="['shipUnderperformanceTcp'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="idle_ops_consumption_tcp"
          >
            Idle TCP
          </th>
          <th
            *ngIf="['shipUnderperformanceTcp'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="maneuvering_tcp"
          >
            Maneuvering TCP
          </th>

          <th
            *ngIf="['Idle', 'Transit', 'CargoOperations'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="fo_maneuvering_consumption"
          >
            HSFO Consumption
          </th>
          <th
            *ngIf="['Idle', 'Transit', 'CargoOperations'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="go_maneuvering_consumption"
          >
            VLSFO Consumption
          </th>
          <th
            *ngIf="['Idle', 'Transit', 'CargoOperations'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="fo_maneuvering_consumption"
          >
            MGO Consumption
          </th>
          <th
            *ngIf="['Idle', 'Transit', 'CargoOperations'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="go_maneuvering_consumption"
          >
            ULSFO Consumption
          </th>
          <th
            *ngIf="['Idle', 'Transit', 'CargoOperations'].includes(activeTab)"
            class="th-text-center2"
            mat-sort-header="go_maneuvering_consumption"
          >
            LSGO Consumption
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let element of paginatedData; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ element.vessel_name }}</td>
          <td>{{ element.vessel_imo }}</td>
          <td>{{ element.vessel_type }}</td>
          <td>{{ element.resolved_port_name }}</td>

          <!-- Show only if design tab is active -->
          <td *ngIf="activeTab === 'shipUnderperformanceDesign'">
            {{ element.actual_cargo_ops_consumption }}
          </td>
          <td *ngIf="activeTab === 'shipUnderperformanceDesign'">
            {{ element.cargo_ops_consumption_design }}
          </td>
          <td *ngIf="activeTab === 'shipUnderperformanceDesign'">
            {{ element.actual_idle_consumption }}
          </td>
          <td *ngIf="activeTab === 'shipUnderperformanceDesign'">
            {{ element.idle_consumption_design }}
          </td>
          <td *ngIf="activeTab === 'shipUnderperformanceDesign'">
            {{ element.actual_maneuvering_consumption }}
          </td>
          <td *ngIf="activeTab === 'shipUnderperformanceDesign'">
            {{ element.maneuvering_consumption_design }}
          </td>

          <!-- Show only if TCP tab is active -->
          <td *ngIf="activeTab === 'shipUnderperformanceTcp'">
            {{ element.actual_cargo_ops_consumption }}
          </td>
          <td *ngIf="activeTab === 'shipUnderperformanceTcp'">
            {{ element.actual_idle_consumption }}
          </td>
          <td *ngIf="activeTab === 'shipUnderperformanceTcp'">
            {{ element.actual_maneuvering_consumption }}
          </td>
          <td *ngIf="activeTab === 'shipUnderperformanceTcp'">
            {{ element.cargo_ops_consumption_tcp }}
          </td>
          <td *ngIf="activeTab === 'shipUnderperformanceTcp'">
            {{ element.idle_consumption_tcp }}
          </td>
          <td *ngIf="activeTab === 'shipUnderperformanceTcp'">
            {{ element.maneuvering_consumption_tcp }}
          </td>
          <!-- Show only if IDLE Transit Cargo Operations tab is active -->
          <td
            *ngIf="['Idle', 'Transit', 'CargoOperations'].includes(activeTab)"
          >
            {{
              element.hsfo_cargo_ops_consumption ??
                element.hsfo_idle_consumption ??
                element.hsfo_maneuvering_consumption
            }}
          </td>
          <td
            *ngIf="['Idle', 'Transit', 'CargoOperations'].includes(activeTab)"
          >
            {{  element.vlsfo_idle_consumption ??
                element.vlsfo_cargo_ops_consumption ??
                element.vlsfo_maneuvering_consumption }}
          </td>
          <td
            *ngIf="['Idle', 'Transit', 'CargoOperations'].includes(activeTab)"
          >
            {{ element.mgo_idle_consumption ??
                element.mgo_cargo_ops_consumption ??
                element.mgo_maneuvering_consumption }}
          </td>
          <td
            *ngIf="['Idle', 'Transit', 'CargoOperations'].includes(activeTab)"
          >
            {{  element.ulsfo_idle_consumption ??
                element.ulsfo_cargo_ops_consumption ??
                element.ulsfo_maneuvering_consumption  }}
          </td>
          <td
            *ngIf="['Idle', 'Transit', 'CargoOperations'].includes(activeTab)"
          >
            {{  element.lsgo_idle_consumption ??
                element.lsgo_cargo_ops_consumption ??
                element.lsgo_maneuvering_consumption }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <mat-paginator
    [length]="elements?.length"
    [pageSizeOptions]="[100]"
    [pageSize]="itemsPerPage"
    (page)="onPageChange($event)"
    showFirstLastButtons
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
  ></mat-paginator>
  <br />
  <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="downloadClick()">
      <mat-icon>download</mat-icon>&nbsp; Download
    </button>
    <button class="btn btn-light hover-button mail" (click)="printTable()">
      <mat-icon>print</mat-icon>&nbsp; Print
    </button>
    <button class="btn btn-light hover-button mail" (click)="exportClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>
  </div>
  <br />
</div>
